import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_instructions_by_shippingContainerIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerId: number, ownerIds?: number[], projectIds?: number[], materialIds?: number[], accountIds?: number[], shipmentIds?: number[], excludeIds?: number[], orderIds?: number[], carrierServiceTypeIds?: number[], containerTypeIds?: number[], carrierIds?: number[] }): 
  Promise<{ result: { Id?: number, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_instructions_by_shippingContainerId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shippingContainerId: number, ownerIds?: number[], projectIds?: number[], materialIds?: number[], accountIds?: number[], shipmentIds?: number[], excludeIds?: number[], orderIds?: number[], carrierServiceTypeIds?: number[], containerTypeIds?: number[], carrierIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, Type?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_instructions_by_shippingContainerId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shippingContainerId: number, ownerIds?: number[], projectIds?: number[], materialIds?: number[], accountIds?: number[], shipmentIds?: number[], excludeIds?: number[], orderIds?: number[], carrierServiceTypeIds?: number[], containerTypeIds?: number[], carrierIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_instructions_by_shippingContainerId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerId: number, ownerIds?: number[], projectIds?: number[], materialIds?: number[], accountIds?: number[], shipmentIds?: number[], excludeIds?: number[], orderIds?: number[], carrierServiceTypeIds?: number[], containerTypeIds?: number[], carrierIds?: number[]    }) {
        if(isNil(inParams.shippingContainerId)) {
          return true; 
        }
      return false;
    }
}
